<template>
  <div id="app" style="height: 100%">
    <el-scrollbar style="height: calc(100% + 17px);" ref="scroll">
      <!--<el-backtop target=".el-scrollbar__wrap">-->
        <!--<div class="vcode">-->
          <!--<img src="/static/images/home/changyiewm.png" alt="">-->
          <!--扫码下载APP-->
        <!--</div>-->
        <!--<div class="back-top">回到顶部</div>-->
      <!--</el-backtop>-->
      <router-view></router-view>
    </el-scrollbar>
  </div>
</template>

<script type="text/javascript">
  import { EventBus } from '@/utils/eventBus';

  export default {
    components: {},
    data() {
      return {

      }
    },
    methods: {
      unicodeToChar(str){
        return eval("'" + str + "'");
      }
    },
    created() {
      // 监听消息
      EventBus.$on('ws-message', (data) => {
        this.$notify({
          title: '系统消息',
          dangerouslyUseHTMLString: true,
          message: data,
          position: 'bottom-right'
        });
      });

      // 不在App.vue中自动检查，等待用户操作或特定页面
    },

    beforeDestroy() {
      EventBus.$off('ws-message');
    },
    mounted() {

    },
    computed: {},
    watch: {
      '$route'() {
        this.$refs.scroll.wrap.scrollTop = 0;
      }
    }
  }
</script>

<style type="text/css" scoped>

  #app {
    height: 100%;
    overflow: hidden;
  }

  .el-backtop {
    width: auto;
    height: auto;
    border-radius: 0;
    display: block
  }

  .el-backtop > .vcode {
    text-align: center;
    width: 100px;
    min-height: 100px;
    padding: 5px;
    background-color: #F6F6F6;
    font-size: 14px;
    text-align: center;
    color: #000;
  }
  .el-backtop > .vcode > img {
    width: 100%;
  }

  .el-backtop > .back-top {
    padding: 10px;
    font-size: 14px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue